var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 36,
    viewBox: "0 0 59 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07503 34.911C1.79171 35.637 2.78242 36 4.04716 36H54.8896C56.1965 36 57.2083 35.637 57.925 34.911C58.6417 34.1851 59 33.2242 59 32.0285V26.5836L46.0997 14.7331C44.6242 13.3238 43.0222 12.6619 41.2937 12.7473C39.6074 12.7046 38.0054 13.3665 36.4877 14.7331L22.3859 27.3523L16.7578 22.2278C15.3666 21.032 13.9543 20.4342 12.5209 20.4342C11.214 20.4342 9.86495 21.0107 8.47374 22.1637L0 29.274L0 32.0285C0 33.2242 0.358342 34.1851 1.07503 34.911Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4459 12.5552C12.8792 13.9644 14.5866 14.669 16.5681 14.669C18.5495 14.669 20.2569 13.9644 21.6902 12.5552C23.1236 11.1032 23.8403 9.35231 23.8403 7.30249C23.8403 5.29537 23.1236 3.58719 21.6902 2.17794C20.2569 0.725979 18.5495 0 16.5681 0C14.5866 0 12.8792 0.725979 11.4459 2.17794C10.0125 3.58719 9.29582 5.29537 9.29582 7.30249C9.29582 9.35231 10.0125 11.1032 11.4459 12.5552Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/placeholder-image.cca5e010287fbabf849e275767907117.svg";
export { ForwardRef as ReactComponent };